<template>
  <div class="interface">
    <div class="title-container">接口管理</div>
    <div class="search-container">
      <el-form ref="form" :model="queryParams" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="queryParams.title" @keypress.native.enter="search" placeholder="输入接口名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="interface-container">
      <div class="mg-bottom16">
        <el-button type="primary" size="small" @click="addHandle">新增接口</el-button>
      </div>
      <div class="table-container">
        <el-table :data="tableData" border>
          <el-table-column prop="title" label="接口名称" min-width="120"></el-table-column>
          <el-table-column prop="type" label="接口类型" min-width="120"></el-table-column>
          <el-table-column prop="action" label="请求方式" min-width="80"></el-table-column>
          <el-table-column prop="path" label="地址" min-width="220"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" min-width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="editHandle(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-container text-align-right">
        <Pagination v-bind:child-msg="pageParams" @pageChange="pageChange"/>
      </div>
    </div>
    <div v-if="interfaceDialog">
      <el-dialog :title="dialogTitle" :visible.sync="interfaceDialog" width="580px" @close="closeDialog">
        <div class="interfaceForm-content">
          <el-form :model="interfaceForm" ref="interfaceForm" :rules="rules" label-width="85px" label-position="left">
            <el-form-item label="接口名称：" prop="title">
              <el-input v-model="interfaceForm.title" placeholder="请输入接口名称"></el-input>
            </el-form-item>
            <el-form-item label="接口类型：" prop="type">
              <el-select v-model="interfaceForm.type" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="(item,index) in interfaceType"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请求方式：" prop="action">
              <el-select v-model="interfaceForm.action" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="(item,index) in interfaceAction"
                  :key="index"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="路由地址：" prop="path">
              <el-input v-model="interfaceForm.path" placeholder="请输入路由地址"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="interfaceDialog = false">取 消</el-button>
          <el-button type="primary" :loading="loading" size="small" @click="interfaceHandle">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import interfaceApi from '@/api/system/interface'
  import Pagination from '@/components/Pagination'

  export default {
    name: 'interface',
    data() {
      return {
        listLoading: false,
        queryParams: {
          page: 1,
          per_page: 10
        },
        pageParams: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        tableData: [],
        dialogTitle: '',
        interfaceDialog: false,
        interfaceForm: {},
        loading: false,
        interfaceType: ['SYS', 'BUS'],
        interfaceAction: ['GET', 'POST', 'PUT', 'DELETE'],
        rules: {
          title: [
            {required: true, message: '接口名称不能为空', trigger: 'blur'}
          ],
          type: [
            {required: true, message: '接口类型不能为空', trigger: 'change'}
          ],
          action: [
            {required: true, message: '请求方式不能为空', trigger: 'change'}
          ],
          path: [
            {required: true, message: '路由地址不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    components: {
      Pagination
    },
    created() {
      this.getInterface()
    },
    methods: {
      getInterface() {
        this.listLoading = true
        this.queryParams.page = this.pageParams.currentPage
        this.queryParams.per_page = this.pageParams.pageSize
        interfaceApi.getInterface(this.queryParams).then(res => {
          if (res.code === 0) {
            this.tableData = res.data.list
            this.pageParams.total = res.data.total
          }
          this.listLoading = false
        }).catch((res) => {
          this.listLoading = false
        })
      },
      addHandle() {
        this.interfaceForm = {}
        this.dialogTitle = '新增接口'
        this.interfaceDialog = true
      },
      editHandle(data) {
        this.interfaceId = data.id
        this.dialogTitle = '编辑接口'
        this.interfaceDialog = true
        this.interfaceForm = data
      },
      getInterfaceDetail(id) {
        interfaceApi.getInterfaceDetail(id).then(res => {
          if (res.code === 0) {
            console.log(res.data)
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      interfaceHandle() {
        this.$refs['interfaceForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            if (this.interfaceId) {
              // 编辑
              interfaceApi.editInterface(this.interfaceId, this.interfaceForm).then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg)
                  this.interfaceDialog = false
                  this.getInterface()
                }
                this.loading = false
              }).catch((err) => {
                this.loading = false
                console.log(err)
              })
            } else {
              // 添加
              interfaceApi.addInterface(this.interfaceForm).then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg)
                  this.interfaceDialog = false
                  this.getInterface()
                }
                this.loading = false
              }).catch((err) => {
                this.loading = false
                console.log(err)
              })
            }
          }
        })
      },
      search() {
        this.queryParams.page = 1
        this.pageParams.currentPage = 1
        this.getInterface()
      },
      // 分页
      pageChange(page) {
        this.pageParams.currentPage = page.currentPage
        this.pageParams.pageSize = page.pageSize
        this.getInterface()
      },
      closeDialog() {
        console.log(323)
        this.interfaceForm = {}
        this.interfaceId = ''
        this.$refs['interfaceForm'].resetFields()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/styles/variables.scss";

  .interfaceForm-content {
    .el-form-item:last-child {
      margin-bottom: 0;
    }
  }
</style>
